import { useTranslation } from "react-i18next";
import { schoolApplicationRequestData } from "src/core/statics/schools-application-request-data/school-application-request-data";

function ApplicationRequestCardComponent() {
  const { i18n, t } = useTranslation();

  return (
    <div
      className={`${
        i18n.language === "ar" ? "-mr-4 mobile:mr-0" : "-ml-4 mobile:ml-0"
      } flex flex-col gap-3 h-fit mobile:h-fit mt-11 p-4`}
    >
      {schoolApplicationRequestData.map((item, index) => (
        <div
          key={index}
          className="flex flex-col items-start max-h-60 pt-3 pb-4 px-1 max-w-[553px] bg-white mobile:max-h-fit rounded-xl drop-shadow-[0_0px_10px_rgba(0,0,0,0.1)]"
        >
          {item.requestStatus === "new" ? (
            <div className="flex justify-center items-center mx-1 mb-3 rounded-md font-ar text-blue-500 h-7 w-32 bg-blue-50">
              {t("applicationRequestCard.component.newRequest")}
            </div>
          ) : item.requestStatus === "accepted" ? (
            <div className="flex justify-center items-center mx-1 mb-3 rounded-md font-ar text-lime-500 h-7 w-32 bg-[#84CC164D]">
              {t("applicationRequestCard.component.accepted")}
            </div>
          ) : (
            <div className="flex justify-center items-center mx-1 mb-3 rounded-md font-ar text-red-500 h-7 w-32 bg-red-50">
              {t("applicationRequestCard.component.rejected")}
            </div>
          )}

          <div className="w-full h-[1px] bg-neutral-200 text-transparent">
            .
          </div>
          <div
            className={`${
              i18n.language === "ar" ? "" : ""
            } grid grid-cols-2 grid-rows-2 mobile:gap-4 font-arLight text-base gap-y-3 gap-x-[105px] py-4 px-2`}
          >
            <div className="text-neutral-800">
              {t("applicationRequestCard.component.student")}
              <div className="text-neutral-400">
                {i18n.language === "ar" ? item.studentName : item.studentNameEn}
              </div>
            </div>
            <div className="text-neutral-800">
              {t("applicationRequestCard.component.id")}
              <div className="text-neutral-400">{item.studentID}</div>
            </div>
            <div className="text-neutral-800">
              {t("applicationRequestCard.component.phoneNumber")}
              <div className="text-neutral-400">{item.phoneNumber}</div>
            </div>
            <div className="text-neutral-800">
              {t("applicationRequestCard.component.educationLevel")}
              <div className="text-neutral-400">
                {i18n.language === "ar"
                  ? item.educationLevel
                  : item.educationLevelEn}
              </div>
            </div>
          </div>
          {item.requestStatus === "new" ? (
            <div className="flex flex-row gap-2 mx-2 mobile:items-center mobile:justify-center mobile:w-[calc(100%-15px)]">
              <div className="flex items-center justify-center text-white bg-mint-500 px-6 py-1.5 rounded-full font-ar text-base cursor-pointer mobile:w-full">
                {t("applicationRequestCard.component.buttonAccept")}
              </div>
              <div className="flex items-center justify-center text-red-500 border-red-500 border px-6 py-1.5 rounded-full font-ar text-base cursor-pointer mobile:w-full">
                {t("applicationRequestCard.component.buttonDeny")}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      ))}
    </div>
  );
}

export default ApplicationRequestCardComponent;
